/** Header avatar menu (ViralWise addition to the OutlierOS header): who is signed in, plan, settings, sign out. */
import { initials } from '../initials';
import { useEffect, useRef, useState } from 'react';
import { CreditCard, LogOut, Settings } from 'lucide-react';

export function AvatarMenu({ name, email, plan, onNavigate, onSignOut }: { name: string; email: string; plan: string; onNavigate: (h: string) => void; onSignOut: () => void }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => !ref.current?.contains(e.target as Node) && setOpen(false);
    const key = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', close);
    window.addEventListener('keydown', key);
    return () => { document.removeEventListener('mousedown', close); window.removeEventListener('keydown', key); };
  }, [open]);
  const item = 'flex w-full items-center gap-2 rounded-lg px-2.5 py-2 text-left text-xs font-semibold hover:bg-secondary';
  return (
    <div ref={ref} className="relative">
      <button aria-label="Account menu" aria-expanded={open} aria-haspopup="menu" onClick={() => setOpen(!open)}
        className="flex h-9 w-9 items-center justify-center rounded-full bg-primary text-sm font-bold text-primary-foreground shadow-sm">
        {initials(name, email)}
      </button>
      {open && (
        <div role="menu" className="absolute right-0 top-11 z-40 w-60 animate-zoom-in rounded-2xl border border-border bg-card p-2 shadow-2xl">
          <div className="border-b border-border px-2.5 pb-2 pt-1">
            <div className="truncate text-sm font-bold">{name}</div>
            <div className="truncate text-xs text-muted-foreground">{email}</div>
            <div className="mt-1 text-[10px] font-bold uppercase tracking-wider text-primary">{plan} plan</div>
          </div>
          <div className="pt-1">
            <button role="menuitem" className={item} onClick={() => { setOpen(false); onNavigate('/settings'); }}><Settings className="h-3.5 w-3.5" />Settings</button>
            <button role="menuitem" className={item} onClick={() => { setOpen(false); onNavigate('/billing'); }}><CreditCard className="h-3.5 w-3.5" />Billing & Plans</button>
            <button role="menuitem" className={`${item} text-rose-600 dark:text-rose-400`} onClick={onSignOut}><LogOut className="h-3.5 w-3.5" />Sign out</button>
          </div>
        </div>
      )}
    </div>
  );
}
